'use client';

import { useRouteAccess } from '@/hooks/use-route-access';

interface RouteGateProps {
  children: React.ReactNode;
  /** Where the affordance leads, exactly as it will be navigated to. */
  route: string;
  fallback?: React.ReactNode;
}

/**
 * Renders an affordance only when the account can open where it leads.
 *
 * `PermissionGate` answers "may this account do X"; this answers "may this
 * account go there", reading the same registry the destination's own guard
 * reads (`@/config/route-access`). Use it on anything that crosses a module
 * boundary — a row action into another stage's detail screen, a card link, a
 * shortcut — so the UI stops offering doors that open onto "Access Denied".
 */
export function RouteGate({
  children,
  route,
  fallback = null
}: RouteGateProps) {
  const canAccess = useRouteAccess();
  return canAccess(route) ? <>{children}</> : <>{fallback}</>;
}
